module.exports = "/_next/static/images/ManageYourRiskExposure@2x-c194494e204dcfa8829021670479c5d9.png";